import { useEffect, useState } from 'react';
import { api } from '../lib/api';

const emptyRule = { platform: 'airbnb', pattern: '', category: '', reply_template: '', active: 1 };

export default function Rules() {
  const [rules, setRules] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(emptyRule);

  const load = () => api.getRules().then(setRules).catch((err) => console.error('Failed to load rules:', err));
  useEffect(() => { load(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editing) {
        await api.updateRule(editing, form);
      } else {
        await api.createRule(form);
      }
      setForm(emptyRule);
      setEditing(null);
      load();
    } catch (err) {
      console.error('Failed to save rule:', err);
    }
  };

  const startEdit = (rule) => {
    setEditing(rule.id);
    setForm({ platform: rule.platform, pattern: rule.pattern, category: rule.category, reply_template: rule.reply_template, active: rule.active });
  };

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Auto-Reply Rules</h1>

      <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow p-6 mb-8">
        <h2 className="text-lg font-semibold mb-4">{editing ? 'Edit Rule' : 'New Rule'}</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <select value={form.platform} onChange={(e) => setForm({ ...form, platform: e.target.value })} className="border border-gray-300 rounded-md px-3 py-2 text-sm bg-white">
            <option value="airbnb">Airbnb</option>
            <option value="booking_com">Booking.com</option>
            <option value="guesty">Guesty</option>
          </select>
          <input value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} placeholder="Category" className="border border-gray-300 rounded-md px-3 py-2 text-sm" required />
          <input value={form.pattern} onChange={(e) => setForm({ ...form, pattern: e.target.value })} placeholder="Pattern (regex or keyword)" className="border border-gray-300 rounded-md px-3 py-2 text-sm md:col-span-2" required />
          <textarea value={form.reply_template} onChange={(e) => setForm({ ...form, reply_template: e.target.value })} placeholder="Reply template" rows={3} className="border border-gray-300 rounded-md px-3 py-2 text-sm md:col-span-2" required />
          <label className="flex items-center gap-2 text-sm">
            <input type="checkbox" checked={!!form.active} onChange={(e) => setForm({ ...form, active: e.target.checked ? 1 : 0 })} />
            Active
          </label>
        </div>
        <div className="flex gap-2 mt-4">
          <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-blue-600">
            {editing ? 'Update' : 'Create'}
          </button>
          {editing && (
            <button type="button" onClick={() => { setEditing(null); setForm(emptyRule); }} className="bg-gray-200 text-gray-700 px-4 py-2 rounded-md text-sm font-medium hover:bg-gray-300">
              Cancel
            </button>
          )}
        </div>
      </form>

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Platform</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Category</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Pattern</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Active</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {rules.map((rule) => (
              <tr key={rule.id}>
                <td className="px-6 py-4 text-sm text-gray-900">{rule.platform}</td>
                <td className="px-6 py-4 text-sm text-gray-500">{rule.category}</td>
                <td className="px-6 py-4 text-sm text-gray-500 font-mono">{rule.pattern}</td>
                <td className="px-6 py-4 text-sm">
                  <span className={`px-2 py-1 rounded-full text-xs ${rule.active ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-500'}`}>
                    {rule.active ? 'Yes' : 'No'}
                  </span>
                </td>
                <td className="px-6 py-4">
                  <button onClick={() => startEdit(rule)} className="text-sm text-blue-600 hover:text-blue-800">Edit</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
